var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDietaryDummyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 42,
    viewBox: "0 0 48 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H0C0 17.625 9.375 27 21 27V40.5C21 41.3438 21.6562 42 22.5 42H25.5C26.25 42 27 41.3438 27 40.5V27C27 15.4688 17.5312 6 6 6ZM42 0C34.0312 0 27.1875 4.40625 23.625 10.875C26.25 13.6875 28.125 17.1562 29.1562 20.9062C39.75 19.875 48 10.875 48 0H42Z",
    fill: "#8B9898"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDietaryDummyLogo);
export default __webpack_public_path__ + "static/media/DietaryDummyLogo.c1d19c96c52c5b6946974ce2450b851d.svg";
export { ForwardRef as ReactComponent };